import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CInput,
  CRow
} from "@coreui/react";
import React, {useEffect, useState} from "react";
import {NAME_DELIMITER} from "../../AppConstants";
import * as searchFormValidation from "../../utils/SearchFormValidation";
import {authorizeToken} from "../../auth/Authorization";
import {getAppBasePath} from "../../utils/CommonUtility";

const NameSearch = (props) => {
  const [nameField, setNameField] = useState({
    firstName: "",
    lastName: ""
  });

  const handleNameSearch = (event) => {
    event.preventDefault();
    props.reInitialize();

    let error = searchFormValidation.fieldValidation("NAME",
      nameField.firstName);
    if (error == null) {
      error = searchFormValidation.fieldValidation("NAME", nameField.lastName);
    }
    if (error != null) {
      props.setValidationError(error);
      props.setSearchValue("");
      return;
    } else {
      props.setValidationError(null);
      authorizeToken()
      .then(response => {
        props.fetchData();
      })
      .catch(error => {
        console.log("invalid token!")
        window.location.replace(getAppBasePath());
      });
    }
  }

  useEffect(() => {
    props.setSearchValue(
      nameField.firstName + NAME_DELIMITER + nameField.lastName);
  }, [nameField.firstName, nameField.lastName]);

  const handleChange = (event) => {
    const {name, value} = event.target;
    setNameField({
      ...nameField,
      [name]: value
    });
  }

  return (
    <>
      <CCard>
        <CCardBody>
          <CRow>
            <CCol sm="4">
              <div className="small text-muted">First Name:</div>
            </CCol>
            <CCol sm="4">
              <div className="small text-muted">Last Name:</div>
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="4">
              <CInput type="text"
                      name="firstName" value={nameField.firstName}
                      onChange={handleChange} required/>
            </CCol>
            <CCol sm="4">
              <CInput type="text"
                      name="lastName" value={nameField.lastName}
                      onChange={handleChange} required/>
            </CCol>
            <CCol sm="4" className="d-none d-md-block">
              <CButton color="primary"
                       className="px-4 btn-block"
                       onClick={handleNameSearch}>Search</CButton>
            </CCol>
          </CRow>
          {props.validationError &&
          <CRow>
            <CCol sm="8">
              <div className="invalidField">{props.validationError}</div>
            </CCol>
          </CRow>
          }
        </CCardBody>
      </CCard>
    </>
  )
}

export default NameSearch;
